import { call, put, takeLatest, select } from 'redux-saga/effects';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { selectQueryParams } from 'yoda-site-components/lib/selectors/QuerySelector';
import { getGeoZipcode } from 'yoda-interfaces/lib/Pdp/GeolocationApi';
import { cachePolicy } from '../config';
import {
    DELIVERY_ZIPCODE_GET_REQUEST_SUCCESS,
    DELIVERY_ZIPCODE_GET_REQUEST_FAILURE,
    DELIVERY_ZIPCODE_GET,
} from '../actionTypes/DeliveryZipcodeActionTypes';

function* getDeliveryZipcode() {
    try {
        const deliveryZipcode = LocalStorage.getData('deliveryZipcode');
        let zipcode;
        let setLocalstorage = true;
        const getQueryParams = yield select(selectQueryParams);
        if (getQueryParams.zipCode) {
            zipcode = getQueryParams.zipCode;
            setLocalstorage = false;
        } else if (
            deliveryZipcode &&
            deliveryZipcode.zipcode &&
            new Date() - new Date(deliveryZipcode.date) <= cachePolicy.minCache * 1000 // microseconds conversion
        ) {
            zipcode = deliveryZipcode.zipcode;
            setLocalstorage = false;
        } else {
            zipcode = yield call(getGeoZipcode);
        }
        yield put({
            type: DELIVERY_ZIPCODE_GET_REQUEST_SUCCESS,
            payload: {
                zipcode,
                setLocalstorage,
            },
        });
    } catch (error) {
        yield put({
            type: DELIVERY_ZIPCODE_GET_REQUEST_FAILURE,
            error,
        });
    }
}

const watchDeliveryZipcodeSaga = function* watchDeliveryZipcodeSaga() {
    yield takeLatest(DELIVERY_ZIPCODE_GET, getDeliveryZipcode);
};

watchDeliveryZipcodeSaga.sagaName = 'deliveryZipcodeSaga';

export default watchDeliveryZipcodeSaga;
